// import loadable from '@loadable/component'

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from "react-router-dom";
import { Helmet } from "react-helmet-async"

import {
    homepage,
    development,
    isSnap,
    carouselAutoplayDelay,
    baseURL,
} from './components/constants'

import './App.css'

import Disclaimer from './components/elements/Disclaimer'

import ConvertPDFtoJPG from './components/tools/ConvertPDFtoJPG'
import ConvertJPGtoPDF from './components/tools/ConvertJPGtoPDF'

import ConvertPDFtoPNG from './components/tools/ConvertPDFtoPNG'
import ConvertPNGtoPDF from './components/tools/ConvertPNGtoPDF'

import ConvertPDFtoGIF from './components/tools/ConvertPDFtoGIF'
import ConvertGIFtoPDF from './components/tools/ConvertGIFtoPDF'

import ConvertPDFtoTIFF from './components/tools/ConvertPDFtoTIFF'
import ConvertTIFFtoPDF from './components/tools/ConvertTIFFtoPDF'

import ConvertWORDtoPDF from './components/tools/ConvertWORDtoPDF'
import ConvertEXCELtoPDF from './components/tools/ConvertEXCELtoPDF'
import ConvertPOWERPOINTtoPDF from './components/tools/ConvertPOWERPOINTtoPDF'

import MergePDF from './components/tools/MergePDF'
import SplitPDF from './components/tools/SplitPDF'
import CompressPDF from './components/tools/CompressPDF'
import RearrangePDF from './components/tools/RearrangePDF'

import SignPDF from './components/tools/SignPDF'
import MakePdfSearchable from './components/tools/MakePdfSearchable'

import DSPErase from './components/tools/DSPErase'
import DSPSignPlacer from './components/tools/DSPSignPlacer'
import ToolsList from './components/tools/ToolsList'

const routeTo = (name: string) => [homepage + '/' + name, homepage + '/' + name + '.html']

const App = () => {
    return (
        <Router>

            {
                isSnap &&
                <Helmet script={[
                    {
                        type: 'text/javascript',
                        src: '/tools/libs/prebuildSnap.js',
                        class: 'prebuildSnap',
                        base: baseURL,
                    },
                ]} />
            }
            
            {
                !isSnap &&
                <Helmet script={[
                    {
                        type: 'text/javascript',
                        innerHTML: 'window.addEventListener("load",()=>{new Swiper(".carousel",{mousewheel:true,spaceBetween:30,loop:true,grabCursor:true,autoplay:{delay:' + carouselAutoplayDelay + ',disableOnInteraction:false},navigation:{nextEl:".swiper-button-next",prevEl:".swiper-button-prev"},pagination:{el:".swiper-pagination",clickable:true,renderBullet:function(i,c){return\'<span class="\'+c+\'"></span>\'}}})});'
                    },
                ]}>
                    {/* <link rel="stylesheet" href="/tools/libs/swiper-bundle.min.css" /> */}
                </Helmet>
            }

            <Disclaimer />

            <Switch>

                <Route path={routeTo("convert-pdf-to-jpg")}>
                    <ConvertPDFtoJPG />
                </Route>

                <Route path={routeTo("convert-pdf-to-png")}>
                    <ConvertPDFtoPNG />
                </Route>

                <Route path={routeTo("convert-pdf-to-gif")}>
                    <ConvertPDFtoGIF />
                </Route>

                <Route path={routeTo("convert-pdf-to-tiff")}>
                    <ConvertPDFtoTIFF />
                </Route>

                <Route path={routeTo("convert-jpg-to-pdf")}>
                    <ConvertJPGtoPDF />
                </Route>

                <Route path={routeTo("convert-png-to-pdf")}>
                    <ConvertPNGtoPDF />
                </Route>

                <Route path={routeTo("convert-gif-to-pdf")}>
                    <ConvertGIFtoPDF />
                </Route>

                <Route path={routeTo("convert-tiff-to-pdf")}>
                    <ConvertTIFFtoPDF />
                </Route>

                <Route path={routeTo("convert-word-to-pdf")}>
                    <ConvertWORDtoPDF />
                </Route>

                <Route path={routeTo("convert-excel-to-pdf")}>
                    <ConvertEXCELtoPDF />
                </Route>

                <Route path={routeTo("convert-powerpoint-to-pdf")}>
                    <ConvertPOWERPOINTtoPDF />
                </Route>

                <Route path={routeTo("merge-pdf")}>
                    <MergePDF />
                </Route>

                <Route path={routeTo("split-pdf")}>
                    <SplitPDF />
                </Route>

                <Route path={routeTo("compress-pdf")}>
                    <CompressPDF />
                </Route>

                <Route path={routeTo("rearrange-pdf")}>
                    <RearrangePDF />
                </Route>

                <Route path={routeTo("sign-pdf")}>
                    <SignPDF />
                </Route>

                <Route path={routeTo("make-pdf-searchable")}>
                    <MakePdfSearchable />
                </Route>
                
                <Route path={routeTo("erase-dsp")}>
                        <DSPErase />
                </Route>
                
                <Route path={routeTo("signPlacer-dsp")}>
                    <DSPSignPlacer />
                </Route>

                {/* {
                    development &&
                    <Route path={routeTo("erase-dsp")}>
                        <DSPErase />
                    </Route>
                } */}

                {
                    development &&
                    <Route exact path={homepage}>
                        <ToolsList />
                    </Route>
                }

                <Redirect to="/" />
            </Switch>
        </Router>
    )
}

export default App
